import React, { Fragment, useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Form, FormGroup, Input, Row, Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { DateRangePicker } from "rsuite";
import Breadcrumb from "../../../layout/breadcrumb";
import withReducer from "../../../store/withReducer";
import reportReducer from "../index";
import moment from "moment";
import AsyncSelect from "react-select/async";
import { mapSearchAutoSuggestion } from "../../../utils/mapper";
import { sellerAutoSuggestionApi, sellerBrandSuggestionApi } from "../../../services/manage-product/productService";
import { getOrderItemReport, exportOrderItemReport } from "./store/orderItemReportSlice";
import CommonDataTable from "../../../share-components/table/commonDataTable";
import {
  formatterDecimal, formatter
} from "../../../utils/common";

import "./styles.scss";

const { afterToday } = DateRangePicker;

const OrderItemReport = (props) => {

  const endDateObj = new Date(new Date().getFullYear() - 1, 11, 31); // Last year's Dec 31
  const startDateObj = new Date(new Date().getFullYear() - 1, 0, 1); // Last year's Jan 1

  const [dateRange, setDateRange] = useState([startDateObj, endDateObj]);
  const [startDate, endDate] = dateRange;

  const authData = useSelector(({ authReducer }) => authReducer);

  const [timer, setTimer] = useState(null);
  const [lastFillters, setLastFillters] = useState(null);
  const [fillterSeller, setFillterSeller] = useState(authData && authData.defaultSeller ? authData.defaultSeller : (authData && authData.defaultSellerOption ? authData.defaultSellerOption : ""));
  const [fillterBrand, setFillterBrand] = useState([{ value: 16, label: "Goddiva" }]);
  const brandIds = fillterBrand ? fillterBrand.map((brand) => brand.value) : null;
  const [filter, setFilter] = useState({
    page: 1,
    pageSize: 10,
    start_date: moment(startDate).format("YYYY-MM-DD"),
    end_date: moment(endDate).format("YYYY-MM-DD"),
    sku: "",
    seller: fillterSeller ? fillterSeller.value : null,
    brand: brandIds,
    // status: searchStatus?.id,
  });

  const dispatch = useDispatch();
  const currentUser = useSelector(({ authReducer }) => authReducer.data.user);
  const [loading, setLoading] = useState(true);
  const orderItemReportState = useSelector(({ report }) => report.orderItemReport);
  const [exportBtnDisabled, setExportBtnDisabled] = useState(false);

  const dataMenu = [
    {
      type: 0,
      text: "Reports",
    },
    {
      type: 0,
      text: "Order Item Report",
    },
  ];

  const getOrderedItemsData = () => {
    if (JSON.stringify(filter) == JSON.stringify(lastFillters)) return;

    setLastFillters({ ...filter });
    setLoading(true);

    dispatch(
      getOrderItemReport(filter)
    ).then((res) => {
      if (!res.error) {
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    getOrderedItemsData();
  }, [dispatch, filter]);

  useEffect(() => {
    const brandIds = fillterBrand ? fillterBrand.map((brand) => brand.value) : null;
    setFilter(prev => ({
      ...prev,
      page: 1,
      start_date: moment(startDate).format("YYYY-MM-DD"),
      end_date: moment(endDate).format("YYYY-MM-DD"),
      seller: fillterSeller ? fillterSeller.value : null,
      brand: brandIds,
    }));
  }, [startDate, endDate, fillterSeller, fillterBrand])


  const afterToday = () => {
    return (date) => date.getTime() > new Date().getTime();
  };

  const onPageSizeChange = (newPageSize) => {
    setFilter(prev => ({
      ...prev,
      page: 1,
      pageSize: newPageSize === 'All' ? orderItemReportState.tableRow : newPageSize
    }));
  }

  const onPageChange = (e) => {
    setFilter({ ...filter, page: e });
  }

  const handleSort = (column, sortDirection) => {
    const sortBy = column.sortField || column.selector; // Use `sortField` if available
    setFilter(prev => ({
      ...prev,
      sortBy, // Get the column field name
      sortOrder: sortDirection, // 'asc' or 'desc'
    }));
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: 50,
      border: "none",
    }),
  };

  const exportFile = () => {
    if (exportBtnDisabled) return;
    setExportBtnDisabled(true);

    dispatch(
      exportOrderItemReport(filter)
    ).then((res) => {
      const link = document.createElement("a");
      link.href = res.payload;
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
      link.remove();
      setExportBtnDisabled(false);
    });
  };

  const tableColumns = [
    {
      name: "Order Name",
      selector: (row) => row.order_name,
      sortable: false,
      sortField: 'order_name', // Custom backend field name
      left: true,
      grow: 0.2, // column size
    },
    {
      name: "Order Date",
      selector: (row) => row.order_date,
      sortable: false,
      sortField: 'order_date', // Custom backend field name
      center: true,
      grow: 0.4, // column size
    },
    {
      name: "SKU",
      selector: (row) => row.sku,
      sortable: false,
      sortField: 'sku', // Custom backend field name
      left: true,
      grow: 0.6, // column size
    },
    {
      name: "Current Price",
      selector: (row) => formatter.format(row.current_product_price),
      sortable: false,
      sortField: 'current_product_price', // Custom backend field name
      right: true,
      grow: 0.3, // column size
    },
    {
      name: "Current Sale Price",
      selector: (row) => formatter.format(row.current_product_sale_price),
      sortable: false,
      sortField: 'current_product_sale_price', // Custom backend field name
      right: true,
      grow: 0.3, // column size
    },
    {
      name: "Current Cost",
      selector: (row) => formatter.format(row.current_product_cost),
      sortable: false,
      sortField: 'current_product_cost', // Custom backend field name
      right: true,
      grow: 0.3, // column size
    },
    {
      name: "High Price",
      selector: (row) => formatter.format(row.hide_product_price),
      sortable: false,
      sortField: 'hide_product_price', // Custom backend field name
      right: true,
      grow: 0.3, // column size
    },
    {
      name: "Actual Price",
      selector: (row) => formatter.format(row.actual_product_price),
      sortable: false,
      sortField: 'actual_product_price', // Custom backend field name
      right: true,
      grow: 0.3, // column size
    },
    {
      name: "Actual Sale Price",
      selector: (row) => formatter.format(row.actual_product_sale_price),
      sortable: false,
      sortField: 'actual_product_sale_price', // Custom backend field name
      right: true,
      grow: 0.3, // column size
    },
    {
      name: "Actual Cost",
      selector: (row) => formatter.format(row.actual_product_cost),
      sortable: false,
      sortField: 'actual_product_cost', // Custom backend field name
      right: true,
      grow: 0.3, // column size
    },
    {
      name: "Order Sale Price",
      selector: (row) => formatter.format(row.order_price),
      sortable: false,
      sortField: 'order_price', // Custom backend field name
      right: true,
      grow: 0.3, // column size
    },
    {
      name: "Order Qty",
      selector: (row) => row.order_qty,
      sortable: false,
      sortField: 'order_qty', // Custom backend field name
      center: true,
      grow: 0.3, // column size
    },
    {
      name: "Currency Rate",
      selector: (row) => row.currency_rate,
      sortable: false,
      sortField: 'currency_rate', // Custom backend field name
      right: true,
      grow: 0.3, // column size
    },
  ];

  const sellerPromiseOption = (inputValue) =>
    new Promise((resolve) => {
      const data = {
        value: inputValue,
      };
      clearTimeout(timer);
      const newTimer = setTimeout(() => {
        resolve(mapSearchAutoSuggestion(sellerAutoSuggestionApi(data)));
      }, 300);
      setTimer(newTimer)
    });

  const brandPromiseOption = (inputValue) =>
    new Promise((resolve) => {
      const data = {
        value: inputValue,
        seller_id: filter.seller,
        check_seller_active: true,
      };
      clearTimeout(timer);
      const newTimer = setTimeout(() => {
        resolve(mapSearchAutoSuggestion(sellerBrandSuggestionApi(data)));
      }, 300);
      setTimer(newTimer)
    });

  return (
    <Fragment>
      <Breadcrumb title="Order Item Report" data={dataMenu} />
      <Container fluid={true} className="product-wrapper hangling-item-page">
        <div className="product-grid">
          <div className="feature-products">
            <Card>
              <Row style={{ justifyContent: "space-between" }}>
                {/* <Col md="4">
                  <div className="p-3">
                    <DateRangePickerPrimary
                      dateRange={dateRange}
                      dateRangeChange={(date) => {
                        setDateRange(date);
                      }}
                      defaultValue={[endDateObj, startDateObj]}
                      disabledDate={afterToday()}
                    />
                  </div>
                </Col> */}
                <Col md="2">
                  <div className="float-right p-3">
                    <Button
                      type="button"
                      color="primary"
                      onClick={() => {
                        exportFile();
                      }}
                      disabled={exportBtnDisabled}
                    >
                      <i className={exportBtnDisabled ? "fa fa-spinner fa-spin mr-1" : "fa fa-download mr-1"}></i>
                      Export Report
                    </Button>
                  </div>
                </Col>
              </Row>
            </Card>
            <Row>
              {currentUser.role.id != 5 && (
                <Col md="">
                  <AsyncSelect
                    className="select2-filter"
                    isClearable={true}
                    defaultOptions
                    value={fillterSeller}
                    placeholder="Select Seller"
                    loadOptions={sellerPromiseOption}
                    styles={customStyles}
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                    onChange={(e) => {
                      setFillterSeller(e);
                    }}
                  />
                </Col>
              )}

              <Col md="">
                <AsyncSelect
                  cacheOptions={false}
                  key={filter.seller}
                  className="select2-filter"
                  isClearable={true}
                  isMulti={true}
                  defaultOptions
                  placeholder="Select Brand"
                  loadOptions={brandPromiseOption}
                  value={fillterBrand}
                  styles={customStyles}
                  // menuPortalTarget={document.body}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  onChange={(e) => {
                    setFillterBrand(e);
                  }}
                />
              </Col>

              <Col md="">
                <Form>
                  <FormGroup className="m-0">
                    <Input
                      className="form-control"
                      type="text"
                      placeholder="Search SKU"
                      onChange={(e) => {
                        setFilter({ ...filter, page: 1, sku: e.target.value });
                      }}
                    />
                    <i className="fa fa-search"></i>
                  </FormGroup>
                </Form>
              </Col>
            </Row>
            <Row></Row>

            <Row>
              <Col sm="12">
                {/* <Card>
                  {loading && (
                      <div className="card-loading">
                          <i className="fa fa-spinner fa-lg spinner" />
                      </div>
                  )}
                </Card> */}
                <Card>
                  <CardBody>
                    <div className="table-responsive product-table">
                      <CommonDataTable
                        headerColumns={tableColumns}
                        gridData={orderItemReportState.items}
                        noAction
                        progressPending={loading}
                        paginationServer
                        paginationTotalRows={orderItemReportState.tableRow}
                        paginationRowsPerPageOptions={[10, 50, 100, 500, 1000]}
                        paginationDefaultPage={filter.page}
                        paginationPerPage={filter.pageSize}
                        onChangePage={onPageChange}
                        onChangeRowsPerPage={onPageSizeChange}
                        onSort={handleSort}  // Sorting event handler
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </Container>
    </Fragment>
  );
};

export default withReducer([{ report: reportReducer }])(OrderItemReport);
